/* eslint max-len: 0 */

import React from 'react';
import styled from 'react-emotion';
import { LinkCard } from './Card';

//import Discord from '../icons/logo/Discord';
//import Behance from '../icons/logo/Behance';
//import YouTube from '../icons/logo/YouTube';

//import LinkedIn from '../icons/logo/LinkedIn';

import GitHub    from '../icons/logo/GitHub';
import Twitter   from '../icons/logo/Twitter';
import Instagram from '../icons/logo/Instagram';

import SlideUp from './ani/SlideUp';
import Browser from '../util/Browser';

const MyLinkCard = styled(LinkCard)`
`;

const Base = styled.div`

 font-size: 1.5rem;
  z-index: 8;
  top: 0px;
  position: relative;
  padding-top: 1.75rem;
  padding-bottom: 2.75rem;
  padding-left: 2rem;
  padding-right: 2rem;
  max-width: 77rem;
  margin-left: auto;
  margin-right: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
  background-color: rgba();
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    grid-template-columns: 1fr;
  }
`;

let SlideUp00 = styled.div``;

const ContactCards = () => {
  if (Browser() === 'chrome') {
    SlideUp00 = SlideUp;
  }
  return (
    <SlideUp00 delay={450} fromX="-60px" fromY="60px">
      <Base>
        <MyLinkCard link="https://www.twitter.com/SondroTW" twitter skewYanim>
          <Twitter />
        Twitter
      </MyLinkCard>
        <MyLinkCard link="https://www.github.com/Sondro" github skewYanim>
          <GitHub />
        GitHub
      </MyLinkCard>
        <MyLinkCard link="https://www.instagram.com/SondroIG" instagram skewYanim>
          <Instagram />
        Instagram
      </MyLinkCard>
      </Base>
    </SlideUp00>
  );
};

/*
const ContactCards = () => {
  if (Browser() === 'chrome') {
    SlideUp00 = SlideUp;
  }
  return (
    <SlideUp00 delay={450} fromX="-60px" fromY="60px">
      <Base>
        <MyLinkCard link="https://www.linkedin.com/in/Sondro" linkedin skewYanim>
          <LinkedIn />
        LinkedIn
      </MyLinkCard>
        <MyLinkCard link="https://www.github.com/Sondro" github skewYanim>
          <GitHub />
        GitHub
      </MyLinkCard>
        <MyLinkCard link="https://www.instagram.com/SondroIG" instagram skewYanim>
          <Instagram />
        Instagram
      </MyLinkCard>
      </Base>
    </SlideUp00>
  );
};

*/

/*
        <MyLinkCard link="https://www.behance.net/" behance>
            <Behance />
            Behance
        </MyLinkCard>
        <MyLinkCard link="https://youtu.be" youtube>
            <YouTube />
            Youtube
        </MyLinkCard>

    <MyLinkCard link="https://www.discordapp.com" discord>
            <Discord />
            Discord
    </MyLinkCard>
*/

export default ContactCards;



// WEBPACK FOOTER //
// ./src/components/ContactCards.jsx